import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Link from '@/components/redesign/JourneyLink';
import { journeyParent, journeyUrl } from '@/components/redesign/journeyNavigation';
import { ChevronRight, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/components/useLanguage';

export default function Breadcrumbs({ items, showBackButton = true }) {
  // items: [{ label: 'Forside', path: '/' }, { label: 'FAQ' }]
  // last item is current page (no link)
  const { t } = useLanguage();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const handleBack = () => {
    if (Number(window.history.state?.idx) > 0) navigate(-1);
    else navigate(journeyUrl(items[items.length - 2]?.path || journeyParent(pathname)));
  };

  return (
    <div className="bg-gray-100 border-b border-gray-200">
      <div className="container mx-auto px-6 py-3">
        <div className="flex items-center justify-between flex-wrap gap-3">
          {/* Breadcrumb trail */}
          <nav className="flex items-center text-sm text-gray-600 flex-wrap">
            {items.map((item, index) => (
              <React.Fragment key={index}>
                {index > 0 && <ChevronRight className="w-4 h-4 mx-2 text-gray-400" />}
                {index === items.length - 1 ? (
                  <span className="font-semibold text-gray-900">{item.label}</span>
                ) : (
                  <Link 
                    to={item.path} 
                    className="hover:text-[#ffdc3e] transition-colors"
                  >
                    {item.label}
                  </Link>
                )}
              </React.Fragment>
            ))}
          </nav>

          {/* Back button */}
          {showBackButton && (
            <Button 
              variant="outline" 
              size="sm" 
              onClick={handleBack}
              className="flex items-center gap-2 border-gray-300 hover:border-[#ffdc3e] hover:bg-[#ffdc3e]/10"
            >
              <ArrowLeft className="w-4 h-4" />
              <span>{t('common.back')}</span>
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}